{{ 'app.copyright' | translate: params() }}
